import api from './index.js'

export const fetchBanners = async (
  currentPage,
  pageSize,
  params,
  sortColumn,
  sortDirection
) => {
  try {
    const queryParams = new URLSearchParams(params).toString() // Convert params object to query string
    const response = await api.get(
      `/admin/banner?pageNumber=${currentPage}&pageSize=${pageSize}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&${queryParams}`
    )

    if (response.status === 200) {
      const data = response.data
      // Handle successful response
      // ...
      return data
    } else {
      throw new Error('Failed to fetch banners')
    }
  } catch (error) {
    // Handle error
    // ...
    throw new Error('Failed to fetch banners')
  }
}
export const fetchBanner = async id => {
  try {
    const response = await api.get(`/admin/banner/${id}`)

    if (response.status === 200) {
      const data = response.data
      // Handle successful response
      // ...
      return data
    } else {
      throw new Error('Failed to fetch banner')
    }
  } catch (error) {
    // Handle error
    // ...
    throw new Error('Failed to fetch banner')
  }
}

export const updateBanner = async (id, bannerData) => {
  try {
    const response = await api.put(`/admin/banner/${id}`, bannerData)

    if (response.status === 200) {
      const data = response.data
      // Handle successful response
      // ...
      return data
    } else {
      throw new Error('Failed to update banner')
    }
  } catch (error) {
    // Handle error
    // ...
    throw new Error('Failed to update banner')
  }
}

export const createBanner = async bannerData => {
  try {
    const response = await api.post('/admin/banner', bannerData)

    if (response.status === 200) {
      const data = response.data
      // Handle successful response
      // ...
      return data
    } else {
      throw new Error('Failed to create banner')
    }
  } catch (error) {
    // Handle error
    // ...
    throw new Error('Failed to create banner')
  }
}

export const deleteBanner = async id => {
  try {
    const response = await api.delete(`/admin/banner/${id}`)

    if (response.status === 200) {
      const data = response.data
      // Handle successful response
      // ...
      return data
    } else {
      throw new Error('Failed to delete banner')
    }
  } catch (error) {
    // Handle error
    // ...
    throw new Error('Failed to delete banner')
  }
}
